import { useEffect } from 'react'
import UserEventApi, { UserEventType } from '../api/UserEventApi'
import { EntityType } from '../types/EntityType'
import useAuth from './useAuth'

const entityTypeToUserEvent: Record<EntityType, UserEventType> = {
    issue: UserEventApi.EVENT_TYPES.SHOW_ALL_ISSUES,
    company: UserEventApi.EVENT_TYPES.SHOW_ALL_COMPANIES,
    news: UserEventApi.EVENT_TYPES.SHOW_ALL_NEWS,
    warrant: UserEventApi.EVENT_TYPES.SHOW_ALL_WARRANTS,
    convertible: UserEventApi.EVENT_TYPES.SHOW_ALL_CONVERTIBLES,
}
const api = new UserEventApi()

const isEntityType = (val: EntityType | UserEventType): val is EntityType => val in entityTypeToUserEvent

export const useLogUserEvent = (entityType: EntityType | UserEventType, eventDetails: Record<string, unknown> = {}) => {
    const { isAuthenticated } = useAuth()
    const eventDetailsStr = JSON.stringify(eventDetails) // Stringify to be used in useEffect

    useEffect(() => {
        if (!isAuthenticated) return

        if (entityType) {
            void (async () => {
                const eventName = isEntityType(entityType) ? entityTypeToUserEvent[entityType] : entityType

                await api.logEvent(eventName, JSON.parse(eventDetailsStr))
            })()
        }
    }, [entityType, eventDetailsStr, isAuthenticated])
}
